/**
 * User-safe group invite error messages.
 */
export function getGroupInviteErrorMessage(err) {
  const code = err?.code || '';
  const msg = (err?.message || '').toLowerCase();

  if (code === 'permission-denied' || msg.includes('permission') || msg.includes('insufficient')) {
    return 'Invite not sent — please confirm you\'re allowed to invite members to this league.';
  }
  if (msg.includes('pending invite')) {
    return 'This player already has a pending invite.';
  }
  if (msg.includes('sign in')) {
    return 'Sign in to invite members.';
  }
  return err?.message || 'Could not send invite.';
}

/** Search failures in the invite modal (Cloud Function path, not Firestore users query). */
export function getGroupSearchErrorMessage(err) {
  const code = err?.code || '';
  const msg = (err?.message || '').toLowerCase();

  if (code === 'permission-denied' || msg.includes('permission') || msg.includes('insufficient')) {
    return 'Could not search players — sign in and try again.';
  }
  if (msg.includes('unauthorized') || msg.includes('sign in')) {
    return 'Sign in to search for players.';
  }
  return err?.message || 'Search failed. Try again.';
}

/**
 * Build a Firestore-safe group invite payload (rules require timestamp fields, not serverTimestamp).
 */
export function buildGroupInvitePayload({
  groupId,
  groupName,
  fromUserId,
  fromDisplayName,
  toUserId,
  now = new Date(),
}) {
  if (!groupId || !fromUserId || !toUserId) {
    throw new Error('Invalid invite.');
  }
  return {
    groupId,
    groupName: groupName || 'League',
    fromUserId,
    fromDisplayName: fromDisplayName || 'Member',
    toUserId,
    status: 'PENDING',
    createdAt: now,
    updatedAt: now,
  };
}

export function groupInviteDocId(groupId, toUserId) {
  return `${groupId}_${toUserId}`;
}
